module.exports = __webpack_public_path__ + "media/images/favicon/www.energiefranken.ch-eb5ea6a647cf8c40d73894c9dfd3303d.webmanifest";